import { Typography } from 'antd'
import { I18nContext } from 'contexts/I18n/I18nProvider'
import dayjs from 'dayjs'
import { ConfigManagementLog, ConfigManagementLogOperation, ConfigManagementLogStatus } from 'modules/operational/rtf/redux/logs/configManagement/types'
import { useContext } from 'react'

type LogEntryProps = {
  entry: ConfigManagementLog
}

export default function LogEntry({entry}: LogEntryProps) {
  const t = useContext(I18nContext)

  function getStatusColor(status: string) {
    if(status?.toUpperCase() === ConfigManagementLogStatus.success){
      return 'is-success'
    }
    return 'is-error'
  }
 
  return (
    <li style={{marginTop: '1rem'}}>
      <div className={`log-item ${getStatusColor(entry.status)}`}>
        <Typography.Title level={4}>
          {t(entry.operation?.toUpperCase() === ConfigManagementLogOperation.upload ? 'general.upload' : 'general.delete')} - {dayjs(entry.createdDate).format('YYYY-MM-DD HH:mm:ss')}
        </Typography.Title>
        <Typography.Text>{t('rtf.configuration_management_logs_file_name')}: {entry.resourceName}</Typography.Text>
        <br/>
        <Typography.Text>{t('rtf.configuration_management_logs_status')}: {entry.status}</Typography.Text>
        <br/>
        <Typography.Text>{t('rtf.configuration_management_logs_user')}: {entry.createdBy}</Typography.Text>
      </div>
    </li>
  )
}
